import styled from 'styled-components';

const S = {};

S.Flex = styled.div`
  display: flex;
  ${({ auto }) => (auto ? 'flex: 1 1 auto;' : '')}
  ${({ justify }) => (justify ? `justify-content: ${justify};` : '')}
  ${({ align }) => (align ? `align-items: ${align};` : '')}
  ${({ wrap }) => (wrap ? `flex-wrap: ${wrap};` : '')}
  flex-direction: ${({ column, reverse }) => {
    const postFix = reverse ? '-reverse' : '';
    return column ? `column${postFix}` : `row${postFix}`;
  }};
`;

export default S;
